// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-banner-panel',
    // #endregion
    // #region computed
    computed: {
        banners() {
            return this.$appHost.store.get("navigation").banner;
        },
    },
    // #endregion
});
// #endregion
